import { useEffect } from 'react'
import { Outlet, useMatch, useNavigate } from 'react-router-dom'
import PageHeader from '../common/PageHeader/PageHeader'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentTab } from '../../actions/commonActions'
import styles from '../../assets/styles/components/families/FamiliesStudentsPage.module.scss'
import { checkLicensePermission } from '../../utility/communityLicense'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'

const tabs = ['students', 'families', 'invite-families']

const FamiliesStudentsPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const pathMatch = useMatch('/students-families/:currentTab')
  const licenseType = useSelector(state => state.user.current_user.communities[0]?.license_type)

  const currentTab = pathMatch?.params?.currentTab

  useEffect(() => {
    dispatch(setCurrentTab('Students-Families'))
  }, [dispatch])

  useEffect(() => {
    if (!currentTab) {
      navigate(`/students-families/${tabs[0]}`)
    }
  }, [currentTab, navigate])

  const FamilyHeaderActionButton = (
    <button
      className='btn btn-primary text-white pull-right mr-2'
      onClick={() => navigate('/students-families/invite-families')}
    >
      Invite Family
    </button>
  )

  const selectTab = (index) => navigate(`/students-families/${tabs[index]}`)

  return (
    <div id={styles.FamiliesStudents}>
      <PageHeader
        title='Students & Families'
        actionComponent={currentTab === 'families' && checkLicensePermission(licenseType, ['standard_legacy']) ? FamilyHeaderActionButton : null}
      />
      <Tabs selectedIndex={tabs.indexOf(currentTab)} onSelect={selectTab}>
        {currentTab !== 'invite-families' && (
          <TabList className={styles.tabList}>
            <Tab className={`${styles.tab} react-tabs__tab`} selectedClassName={styles.activeTab}>Students</Tab>
            <Tab className={`${styles.tab} react-tabs__tab`} selectedClassName={styles.activeTab}>Families</Tab>
          </TabList>
        )}
        <TabPanel className={styles.tabPanel} forceRender>
          <Outlet />
        </TabPanel>
        <TabPanel />
      </Tabs>
    </div>
  )
}


export default FamiliesStudentsPage
